<template>
  <div>
    <Row style="padding: 20px">
      <Col span="24">
        <div class="status">
          <div
            :class="[
              'status-item',
              params.queryStatus == '' ? 'status-item-active' : '',
            ]"
            @click="statusChange('')"
            v-access="'order.list.query'"
          >
            全部
          </div>
          <div
            :class="[
              'status-item',
              params.queryStatus == '10' ? 'status-item-active' : '',
            ]"
            @click="statusChange('10')"
            v-access="'order.list.query'"
          >
            待付款
          </div>
          <div
            :class="[
              'status-item',
              params.queryStatus == '30' ? 'status-item-active' : '',
            ]"
            @click="statusChange('30')"
            v-access="'order.list.query'"
          >
            待发货
          </div>
          <div
            :class="[
              'status-item',
              params.queryStatus == '40' ? 'status-item-active' : '',
            ]"
            @click="statusChange('40')"
            v-access="'order.list.query'"
          >
            已发货
          </div>
          <div
            :class="[
              'status-item',
              params.queryStatus == '45' ? 'status-item-active' : '',
            ]"
            @click="statusChange('45')"
            v-access="'order.list.query'"
          >
            已完成
          </div>
          <div
            :class="[
              'status-item',
              params.queryStatus == '0' ? 'status-item-active' : '',
            ]"
            @click="statusChange('0')"
            v-access="'order.list.query'"
          >
            已关闭
          </div>
          <div
            :class="[
              'status-item',
              params.queryStatus == '21' ? 'status-item-active' : '',
            ]"
            @click="statusChange('21')"
            v-access="'order.list.query'"
          >
            待确认
          </div>
        </div>
      </Col>
      <Col span="12">
        <!-- 新增查询字段 -->
        <DatePicker
          type="daterange"
          format="yyyy-MM-dd HH:mm:ss"
          :options="options"
          placement="bottom-start"
          placeholder="请选择时间范围"
          v-model="seTime"
          class="public-inp"
          style="width: 290px !important"
        ></DatePicker>
        <Select
          v-model="params.payChannelCode"
          placeholder="请选择支付方式"
          class="public-inp"
        >
          <Option
            v-for="item in payChannelList"
            :value="item.channelCode"
            :key="item.channelCode"
            >{{ item.channelName }}</Option
          >
        </Select>
        <Select
          v-model="params.erpOrderStatus"
          placeholder="请选择erp订单状态"
          class="public-inp"
        >
          <Option
            v-for="item in erpStatus"
            :value="item.code"
            :key="item.label"
            >{{ item.label }}</Option
          >
        </Select>
        <Input
          style="width: 30%"
          v-model="params.skuName"
          placeholder="请输入商品名称"
          class="search"
        />
        <Input
          style="width: 30%"
          v-model="params.orderId"
          placeholder="请输入订单编码"
          class="search"
        />
        <!-- <Input
          style="width: 30%"
          v-model="params.spCode"
          placeholder="资金商编码"
          class="search"
        />
        <Input
          style="width: 30%"
          v-model="params.receivePerson"
          placeholder="收货人"
          class="search"
        /> -->
        <Input
          style="width: 30%"
          v-model="codeAname"
          placeholder="请输入门店编码/名称"
          class="search"
        />
        <Button
          type="primary"
          icon="md-search"
          @click="getList"
          v-access="'order.list.query'"
          >搜索</Button
        >
        <Button @click="resetList" v-access="'order.list.reset'">重置</Button>
      </Col>
      <Col span="12">
        <Button type="primary" class="add" @click="batchSendErp"
          >批量推送ERP</Button
        >
        <Button
          type="primary"
          icon="md-cloud-download"
          class="add"
          @click="importHandler"
          >导入</Button
        >
        <Button
          type="primary"
          icon="md-cloud-upload"
          class="add"
          @click="exportHandler"
          >导出</Button
        >
      </Col>
      <Col span="24">
        <Table
          class="table"
          border
          stripe
          :loading="loading"
          :columns="columns"
          @on-selection-change="handleSelect"
          :data="orderList.data || []"
        >
          <template slot-scope="{ index }" slot="no">
            <span>{{ params.pageSize * (params.page - 1) + index + 1 }}</span>
          </template>
          <template slot-scope="{ row }" slot="status">
            <p>{{ row.status | statusFilter }}</p>
          </template>
          <template slot-scope="{ row }" slot="retType">
            <p>{{ row.retType | retTypeFilter }}</p>
          </template>
          <template slot-scope="{ row, index }" slot="orderId">
            <a @click="detail(row, index)">{{ row.orderId || "-" }}</a>
          </template>
          <template slot-scope="{ row, index }" slot="action">
            <!--  10：待付款; 30:待发货 40:待收货 45:已完成 0：已关闭  21:待确认-->
            <p
              class="p-button"
              v-if="row.status == 10"
              @click="cancelOrder(row, index)"
              v-access="'order.list.edit'"
            >
              取消订单
            </p>
            <p
              v-if="row.status == 30"
              class="p-button"
              @click="sendERP(row, index)"
              v-access="'order.list.edit'"
            >
              推送ERP
            </p>
            <p
              v-if="row.status == 21"
              class="p-button"
              @click="confirmOrder(row, index)"
              v-access="'order.list.edit'"
            >
              确认订单
            </p>
            <p
              class="p-button"
              @click="addmark(row, index)"
              v-access="'order.list.edit'"
            >
              添加备注
            </p>
            <!-- <p class="p-button" v-if="row.status == 10 || row.status == 30" @click="changeAdr(row, index)">修改收货地址</p> 
            <p class="p-button" @click="detail(row, index)">推送订单</p>
            <p class="p-button" @click="detail(row, index)">推送支付单</p> -->
          </template>
          <template slot-scope="{ row, index }" slot="skuList">
            <div v-if="!row.show_list">
              <p v-if="row.skuList">
                {{ row.skuList[0].skuName }} * {{ row.skuList[0].count }}
              </p>
            </div>
            <div v-else>
              <div v-for="(item, index) in row.skuList" :key="index">
                {{ item.skuName }} *{{ item.count }}
              </div>
            </div>

            <div v-if="row.skuList && row.skuList.length > 1">
              <Icon
                type="ios-arrow-down"
                v-if="!row.show_list"
                style="text-align: right; width: 100%"
                @click="toggle(index)"
              />
              <Icon
                type="ios-arrow-up"
                v-if="row.show_list"
                style="text-align: right; width: 100%"
                @click="toggle(index)"
              />
            </div>
          </template>
          <template slot-scope="{ row }" slot="amt">
            <p>订单金额：{{ row.skuTotalAmt }}</p>
            <p>使用返利：{{ row.rebateAmt }}</p>
            <p>实付金额：{{ row.realTotalAmt }}</p>
          </template>
          <template slot-scope="{ row }" slot="orderTime">
            <p>下单时间:{{ row.orderTime }}</p>
            <p>付款方式：{{ row.payChannelName }}</p>
          </template>
        </Table>
        <Page
          :style="{ float: 'right', marginTop: '10px' }"
          :total="orderList.total"
          show-sizer
          show-total
          prev-text="Previous"
          next-text="Next"
          show-elevator
          @on-change="pageNumChange"
          @on-page-size-change="pageSizeChange"
        />
      </Col>
    </Row>

    <Modal
      v-model="addmarkModalVisible"
      title="添加备注"
      width="70%"
      :footer-hide="true"
    >
      <Form :label-width="80">
        <FormItem label="备注：">
          <Input v-model="newMarkValue" type="textarea"></Input>
        </FormItem>
        <div style="text-align: right; padding: 20px 0">
          <Button size="large" type="default" @click="closeAddMarkModal"
            >取消</Button
          >
          <Button size="large" type="primary" @click="addMarkHandler"
            >确认</Button
          >
        </div>
      </Form>
    </Modal>
    <Modal
      v-model="delModalVisible"
      title="取消订单"
      width="70%"
      @on-ok="delOrder"
      @on-cancel="cancelAction"
    >
      <Form :label-width="80">
        <FormItem label="操作备注：">
          <Input v-model="delRemark" type="textarea"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal
      v-model="sendModalVisible"
      title="推送ERP订单"
      width="70%"
      @on-ok="commSend"
      @on-cancel="cancelAction"
    >
      <Form :label-width="80">
        <FormItem label="操作备注：">
          <Input v-model="sendRemark" type="textarea"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal
      v-model="changeAdrModalVisible"
      title="修改收货地址"
      width="70%"
      :footer-hide="true"
    >
      <Form
        ref="newAdr"
        :model="newAdr"
        :label-width="80"
        :rules="changeAddressFormRules"
      >
        <div style="padding: 10px 20px 20px 20px; font-weight: bold">
          <p>
            <span style="margin-right: 10px">
              {{ (currentRow && currentRow.orderId) || "" }}
            </span>
            <Tag color="red">{{
              currentRow && currentRow.status | statusFilter
            }}</Tag>
          </p>
        </div>
        <FormItem label="收货人：">
          <Input v-model="newAdr.receivePerson"></Input>
        </FormItem>
        <FormItem label="手机号：" prop="receiveMobile">
          <Input v-model="newAdr.receiveMobile"></Input>
        </FormItem>
        <FormItem label="所属区域：">
          <Cascader
            v-model="currentAddress"
            :data="formatedBaseAreaAll"
            @on-change="cascaderChange"
          ></Cascader>
        </FormItem>
        <FormItem label="街道：">
          <Input v-model="newAdr.street" type="textarea"></Input>
        </FormItem>
        <FormItem label="详细地址：">
          <Input v-model="newAdr.addr" type="textarea"></Input>
        </FormItem>
        <div style="text-align: right; padding: 20px 0">
          <Button size="large" type="default" @click="closeChangeAdrModal"
            >取消</Button
          >
          <Button size="large" type="primary" @click="changeAdrHanlder"
            >确认</Button
          >
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
const options = {
  shortcuts: [
    {
      text: "1 week",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        return [start, end];
      },
    },
    {
      text: "1 month",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        return [start, end];
      },
    },
    {
      text: "3 months",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        return [start, end];
      },
    },
  ],
};
const columns = [
  {
    type: "selection",
    width: 60,
    align: "center",
    fixed: "left",
  },
  {
    title: "序号",
    slot: "no",
    width: 80,
    fixed: "left",
  },
  {
    title: "订单编码",
    slot: "orderId",
    width: 210,
  },
  {
    title: "经销商编码",
    key: "spCode",
    width: 100,
  },
  {
    title: "经销商名称",
    key: "spName",
    width: 100,
  },
  {
    title: "门店名称",
    key: "retName",
    width: 100,
  },
  {
    title: "门店编码",
    key: "retCode",
    width: 150,
  },
  {
    title: "门店类型",
    slot: "retType",
    width: 100,
  },
  {
    title: "订单|实付金额",
    slot: "amt",
    width: 150,
  },
  // {
  //   title: "订单总金额",
  //   key: "skuTotalAmt",
  // },
  // {
  //   title: "优惠总金额",
  //   key: "discountTotalAmt",
  // },
  {
    title: "下单/付款时间",
    slot: "orderTime",
    width: 200,
  },
  {
    title: "订单状态",
    slot: "status",
    width: 100,
  },
  // {
  //   title: "支付方式",
  //   key: "payChannelCode",
  //   width: 100,
  // },
  {
    title: "商品信息",
    slot: "skuList",
    width: 200,
  },
  {
    title: "收货信息",
    key: "addressInfo",
    width: 150,
    render(h, params) {
      let p = params.row.addressInfo,
        origin_text =
          "收货人：" +
          p.receivePerson +
          "联系电话：" +
          p.receiveMobile +
          "地址：" +
          p.addr,
        text = "";
      if (p) {
        text =
          "收货人：" +
          p.receivePerson +
          "\n" +
          "联系电话：" +
          p.receiveMobile +
          "\n" +
          "地址：" +
          p.addr;
        if (text.length > 20) {
          text = text.slice(0, 20) + "...";
        }
      }
      return h("div", [
        h(
          "Tooltip",
          {
            props: {
              placement: "top",
              transfer: true,
            },
          },
          [
            text,
            h(
              "span",
              {
                slot: "content",
                style: {
                  whiteSpace: "normal",
                },
              },
              origin_text
            ),
          ]
        ),
      ]);
    },
  },
  {
    title: "操作",
    slot: "action",
    width: 150,
    fixed: "right",
  },
];
export default {
  data() {
    return {
      loading: false,
      columns,
      options,
      currentRow: null,
      addmarkModalVisible: false, // 添加备注modal
      newMarkValue: "", // 新增备注

      delModalVisible: false, //取消订单
      delRemark: "", //删除操作备注

      sendModalVisible: false, //取消订单
      sendRemark: "", //删除操作备注

      changeAdrModalVisible: false, // 修改收货地址modal
      currentAddress: [],
      newAdr: {
        orderId: "",
        receiveMobile: "",
        receivePerson: "",
        street: "",
        addr: "",
        atpids: "",
        atnames: "",
      }, // 修改收货地址
      changeAddressFormRules: {
        receiveMobile: [
          {
            type: "string",
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的电话格式",
            trigger: "blur",
          },
        ],
      },

      params: {
        pageSize: 10,
        page: 1,
        skuName: "",
        orderId: "",
        spCode: "",
        receivePerson: "",
        retCode: "",
        retName: "",
        queryStatus: "", // null：查全部; 10：待付款; 30:待发货 40:待收货 45:已完成 0：已关闭
        startDate: "",
        endDate: "",
        erpOrderStatus: "",
        payChannelCode: "",
      },
      codeAname: "",
      seTime: [],
      payChannelList: [
        {
          channelCode: "null",
          channelName: "全部",
        },
        {
          channelCode: "NetPay",
          channelName: "招行一网通",
        },
        {
          channelCode: "WeChat",
          channelName: "招行-微信支付",
        },
        {
          channelCode: "AliPay",
          channelName: "招行-支付宝",
        },
        {
          channelCode: "OFFLINE",
          channelName: "线下支付",
        },
      ],
      erpStatus: [
        {
          code: 1,
          label: "正常",
        },
        {
          code: 0,
          label: "异常",
        },
      ],
      orderIdList: [],
    };
  },
  computed: {
    ...mapGetters({
      orderList: "order/getOrderList",
    }),
    ...mapGetters("base", {
      baseAreaAll: "getBaseAreaAll",
    }),
    formatedBaseAreaAll() {
      return this.convertAddressTree(this.baseAreaAll);
    },
  },
  filters: {
    statusFilter(status) {
      let sTxt = "";
      switch (+status) {
        case 30:
          sTxt = "待发货";
          break;
        case 40:
          sTxt = "已发货";
          break;
        case 45:
          sTxt = "已完成";
          break;
        case 0:
          sTxt = "已关闭";
          break;
        case 10:
          sTxt = "待付款";
          break;
        case 21:
          sTxt = "待确认";
          break;
        default:
          break;
      }

      return sTxt;
    },
    retTypeFilter(retType) {
      let type_list = [
        {
          retType: 0,
          name: "单体门店",
        },
        {
          retType: 1,
          name: "总仓配货门店",
        },
        {
          retType: 2,
          name: "总仓和门店",
        },
        {
          retType: 3,
          name: "总仓",
        },
        {
          retType: 4,
          name: "总仓",
        },
        {
          retType: 6,
          name: "连锁总仓",
        },
        {
          retType: 7,
          name: "总仓分店",
        },
        {
          retType: 8,
          name: "加盟连锁",
        },
        {
          retType: 13,
          name: "总仓(KA)",
        },
        {
          retType: 15,
          name: "总仓配货门店(KA)",
        },
        {
          retType: 17,
          name: "分销商供货总仓",
        },
        {
          retType: 18,
          name: "分销商供货总仓和门店",
        },
        {
          retType: 19,
          name: "分销商供货门店",
        },
        {
          retType: 20,
          name: "分销商总仓配货门店",
        },
        {
          retType: 21,
          name: "联盟总店",
        },
        {
          retType: 22,
          name: "联盟分店",
        },
      ];
      if (retType) {
        return type_list.filter((item) => item.retType == retType)[0].name;
      } else {
        return "无";
      }
    },
  },
  created() {
    this.getList();
    this.$store.dispatch("base/getBaseAreaAll");
  },
  methods: {
    handleSelect(e) {
      let list = [];
      e.map((item) => {
        list.push(item.orderId);
      });
      this.orderIdList = list;
    },
    sendERP(row, index) {
      this.currentRow = row;
      this.sendModalVisible = true;
    },
    // 批量推送
    batchSendErp() {
      let orderIdList = this.orderIdList;
      if (orderIdList.length == 0) {
        this.$Message.error("尚未选择推送订单");
        return false;
      }
      this.sendModalVisible = true;
    },
    commSend() {
      let va = [];
      if (this.currentRow) {
        va = [this.currentRow.orderId];
      } else {
        va = this.orderIdList;
      }
      let params = {
        orderIdList: va,
        remark: this.sendRemark,
      };
      this.$api.pushOrder(params).then((res) => {
        if (res.code == 200) {
          this.$Message.success("推送成功");
          this.orderIdList = [];
          this.currentRow = null;
          this.getList();
          this.cancelAction();
        } else {
          this.currentRow = null;
          this.orderIdList = [];
          this.$Message.error(res.msg || "推送失败");
        }
      });
    },
    toggle(index) {
      this.$set(
        this.orderList.data[index],
        "show_list",
        !this.orderList.data[index].show_list
      );
    },
    initTime(t, i) {
      if (!t[i]) {
        return "";
      }
      let d = t[i];
      let str = new Date(d);
      return this.tools.formatDate(str, true);
    },
    // 列表
    getList() {
      this.loading = true;
      this.params.retCode = this.codeAname;
      this.params.retName = this.codeAname;
      this.params.startDate = this.initTime(this.seTime, 0);
      this.params.endDate = this.initTime(this.seTime, 1);
      this.$store
        .dispatch("order/getOrderList", this.params)
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
          this.orderList.data.forEach((item, index) => {
            if (item.status != 30) {
              this.$set(this.orderList.data[index], "_disabled", true);
            } else {
              this.$set(this.orderList.data[index], "_disabled", false);
            }
          });
        });
    },
    // 页码
    pageNumChange(pageNum) {
      this.params.page = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.params.pageSize = pageSize;
      // 页码变动触发pageNumChange
      if (this.params.page == 1) {
        this.getList();
      } else {
        this.params.page = 1;
      }
    },
    // 重置
    resetList() {
      this.params.page = 1;
      this.params.pageSize = 10;
      this.params.skuName = "";
      this.params.orderId = "";
      this.params.spCode = "";
      this.params.receivePerson = "";
      this.params.retCode = "";
      this.params.erpOrderStatus = "";
      this.seTime = [];
      this.codeAname = "";
      this.getList();
    },
    statusChange(val) {
      this.params.queryStatus = val;
      this.getList();
    },

    // 添加
    create() {
      this.$router.push({
        path: "create",
        // query:
      });
    },
    // 导入
    importHandler() {},
    // 导出
    exportHandler() {
      let data = JSON.parse(JSON.stringify(this.params));
      data.erpOrderStatus = data.erpOrderStatus || 1;
      data.retCode = this.codeAname;
      data.retName = this.codeAname;
      data.startDate = this.initTime(this.seTime, 0);
      data.endDate = this.initTime(this.seTime, 1);
      data.queryType = 0;
      data.platformCodes = "";
      data.spCodes = "";
      data.retCodes = "";
      this.$api.orderExport(data).then((res) => {
        if (res.code == "200") {
          try {
            let elemIF = document.createElement("iframe");
            elemIF.src = res.data.url;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
          } catch (e) {
            this.$Message.error("下载异常！");
          }
        } else {
          this.$Message.error("导出失败" + res.message);
        }
      });
    },
    // 详情
    detail(row, index) {
      this.$router.push({
        path: "detail",
        query: {
          orderId: row.orderId,
        },
      });
    },
    addmark(row, index) {
      this.currentRow = row;
      this.newMarkValue = row.remark || "";
      this.addmarkModalVisible = true;
    },
    cancelOrder(row, index) {
      this.currentRow = row;
      this.delModalVisible = true;
    },
    delOrder() {
      this.$store
        .dispatch("order/orderCancel", {
          mergeOrderId: this.currentRow.mergeOrderId,
          remark: this.delRemark,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$Message.success("取消成功");
            // 刷新列表
            this.getList();
            this.cancelAction();
          } else {
            this.$Message.error(res.msg || "取消失败");
          }
        })
        .catch((err) => {
          this.$Message.error(err);
        });
    },
    addMarkHandler() {
      this.$store
        .dispatch("order/orderEditRemark", {
          orderId: this.currentRow.orderId,
          remark: this.newMarkValue,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$Message.success("添加成功");
            // 刷新列表
            this.getList();
            this.closeAddMarkModal();
          } else {
            this.$Message.error(res.msg || "添加失败");
          }
        })
        .catch((err) => {
          this.$Message.error(err);
        });
    },
    closeAddMarkModal() {
      this.addmarkModalVisible = false;
      this.currentRow = null;
      this.newMarkValue = "";
    },
    cancelAction() {
      this.delModalVisible = false;
      this.currentRow = null;
      this.delRemark = "";

      this.sendModalVisible = false;
      this.sendRemark = "";
    },
    changeAdr(row, index) {
      this.currentRow = row;
      this.newAdr.orderId = this.currentRow.orderId;

      if (this.currentRow.addressInfo) {
        this.newAdr.receiveMobile =
          this.currentRow.addressInfo.receiveMobile || "";
        this.newAdr.receivePerson =
          this.currentRow.addressInfo.receivePerson || "";
        this.newAdr.addr = this.currentRow.addressInfo.addr || "";
      }
      this.changeAdrModalVisible = true;
    },
    changeAdrHanlder() {
      this.$refs["newAdr"].validate((valid) => {
        if (valid) {
          this.$store
            .dispatch("order/orderEditAddress", this.newAdr)
            .then((res) => {
              if (res.code == 200) {
                this.$Message.success("修改成功");
                // 刷新列表
                this.getList();
                this.closeChangeAdrModal();
              } else {
                this.$Message.error(res.msg || "修改失败");
              }
            })
            .catch((err) => {
              this.$Message.error(err);
            });
        }
      });
    },
    closeChangeAdrModal() {
      this.changeAdrModalVisible = false;
      this.currentRow = null;
      this.newAdr = {
        orderId: "",
        receiveMobile: "",
        receivePerson: "",
        street: "",
        addr: "",
        atpids: "",
        atnames: "",
      };
    },
    convertAddressTree(tree) {
      const result = [];

      tree.forEach((item) => {
        let { atpids: value, name: label, atnames, children } = item;

        if (children) {
          children = this.convertAddressTree(children);
        }
        result.push({ value, label, atnames, children });
      });
      return result;
    },
    cascaderChange(value, selectedData) {
      const result = selectedData[selectedData.length - 1];
      this.newAdr.atnames = result.atnames;
      this.newAdr.atpids = result.value;
    },
    // 审核订单
    confirmOrder(row, index) {
      this.$Modal.confirm({
        title: "提示",
        content: `确认审核通过该订单吗`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          this.$store
            .dispatch("order/orderApprove", {
              orderId: row.orderId,
            })
            .then((res) => {
              if (res.code == 200) {
                this.$Message.success("审核成功");
                // 刷新列表
                this.getList();
              } else {
                this.$Message.error(res.msg || "审核失败");
              }
            })
            .catch((err) => {
              this.$Message.error(err);
            });
        },
      });
    },
  },
};
</script>
<style scoped>
.status {
  max-width: 40%;
  display: flex;
  margin-bottom: 15px;
}

.status .status-item {
  height: 32px;
  flex: 1;
  line-height: 30px;
  font-size: 12px;
  padding: 0 20px;
  cursor: pointer;
  user-select: none;
  transition: 0.25s;
  outline: none;
  background-color: #fff;
  color: #5586ff;
  border: 1px solid #5586ff;
  white-space: nowrap;
}

.status .status-item:first-child {
  border-radius: 4px 0 0 4px;
}

.status .status-item:last-child {
  border-radius: 0 4px 4px 0;
}

.status .status-item:not(:first-child) {
  margin-left: -1px;
}

.status .status-item-active {
  color: #fff;
  border-color: #5586ff;
  background-color: #5586ff;
}

.p-button {
  color: #2d8cf0;
  cursor: default;
}

.p-button:hover {
  cursor: pointer;
  color: #57a3f3;
}

.add {
  float: right;
  margin-right: 0;
  margin-left: 15px;
}
.table {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/list.vue